import React, { useState, useRef, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeftIcon, ArrowRightIcon, PlayIcon, StopIcon } from "@heroicons/react/24/outline";
import { useLanguage } from "../context/LanguageContext";

function BrownBookPage() {
  const navigate = useNavigate();
  const audioRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const { lang } = useLanguage();

  // --- Tabs ---
  const tabs = [
    { id: "oal", label: "Once a Live" },
  ];

  // --- Pages for each tab ---
  const tabPages = {
    oal: [
      {
        left: {
          title: "What is Once a Live?",
          text_th: "กาลครั้งหนึ่ง พวกเราได้สัมผัสถึงคำว่า… “ชีวิต” และเริ่มใช้ชีวิตนับแต่นั้น\n\nเราได้รวบรวมความทรงจำและเรื่องราวจากหลากหลายดินแดน มาจดบันทึกลงในหนังสือที่นับวันรอให้มีผู้อ่านสักครั้ง\n\nกระทั่ง เราค้นพบวิธีที่จะทำให้หนังสือแสนอัศจรรย์เหล่านี้.. ได้ออกมาโลดแล่นในโลกแห่งความเป็นจริง หรือก็คือ พวกเขานั้นมีชีวิต เหล่าตัวละครเริ่มวิวัฒนาการด้านความรู้สึก การนึกคิด ตลอดจนหัวใจ เราจึงตัดสินใจที่จะเปิดประตูรถไฟ เพื่อให้ตัวละครเหล่านี้ได้พบปะผู้คน ซึ่งถูกขนานนามว่า “ผู้โดยสาร”",
          text_en: "“Once upon a time, we were alive, and ever after, we live.”\n\nWe’ve gathered memories and stories from many different places and written them in books that have waited a long time to be read just once.\n\nOne day, we discovered a way to bring all our wondrous books to life, which means they are now alive! The characters started to develop their own feelings, thoughts, and hearts. We then decided to open our doors so these characters could interact with other people, referred to as “the passengers.”"
        },
        right: {
          title: "What is Once a Live?",
          text_th: "Once A Live คือรถไฟหมายเลข 18680 ที่สามารถท่องผ่านเวลาและความฝัน ใช่แล้ว ท่านฟังไม่ผิด “ความฝัน” พวกเรานำเสนอจิตใต้สำนึกของท่านผ่านหลากหลายเรื่องราว สรรค์สร้างสถานีต่าง ๆ และเชิญผู้โดยสารมาเข้าร่วมการเดินทางที่ไม่รู้จบ",
          text_en: "Once A Live is a train number 18680 that can travel through time and dreams. Yes, you heard it right: “human dreams.” We have represented your subconscious minds through various stories, created stations, and invited passengers to join us on a journey that goes round and round, much like a carousel."
        }
      },
      {
        left: {
          title: "What is Once a Live?",
          text_th: "เมื่อท่านเริ่มเดินทางไปกับเรา ท่านจะได้พบกับประสบการณ์ที่เป็นดั่งฝัน แต่ไม่ต้องกังวลไป มันไม่อันตรายเลยสักนิด ตราบเท่าที่ท่านปฏิบัติตามคำแนะนำของพวกเรา\n\n1. กรุณาเก็บรักษาตั๋วรถไฟของท่านเป็นอย่างดี และให้ความร่วมมือในการตรวจสอบจากวันซ์หรือไลฟ์\n2. เจ้าหน้าที่ของเราพร้อมเสมอหากท่านต้องการความช่วยเหลือ ไม่ว่าเรื่องใด อย่าลังเลที่จะแจ้งให้เราทราบ\n3. ตัวละครของเรานั้นมีการรับรู้และสติเป็นของตัวเอง อันที่จริงพวกเขาก็ไม่ต่างอะไรกับมนุษย์อีกคนหนึ่ง ดังนั้นกรุณาให้เกียรติพวกเขาด้วย",
          text_en: "As you travel with us, you will encounter many dreamy experiences, but do not worry; it’s not dangerous as long as you follow our instructions.\n\nOnce A Live’s Passenger Instructions\n\n1. Please keep your ticket with you at all times. If Once or Live asks to check your ticket, please cooperate.\n2. Our staff is here to assist you. If you need any help, do not hesitate to let us know."
        },
        right: {
          title: "What is Once a Live?",
          text_th: "4. โปรดใช้วิจารณญาณในการแบ่งแยกระหว่างโลกแห่งความเป็นจริงและนิยาย แต่หากท่านไม่แน่ใจว่าจะประพฤติตนอย่างไร ตัวละครของพวกเราจะชี้แนวทางให้ท่านปฏิบัติอย่างถูกต้องเหมาะสม\n5. ตัวละครแต่ละตัว มีวิธีการสื่อสารเป็นของตัวเอง กระนั้นพวกเขาก็เป็นมิตรและพร้อมจะทำให้ท่านเพลิดเพลินไปกับการเดินทาง ดังนั้นอย่าลืมที่จะผ่อนคลายและสนุกกับกิจกรรมที่ท่านจะได้สัมผัส\n\nขอบคุณที่เข้าร่วมการเดินทางสุดพิเศษครั้งหนึ่งในชีวิตอันแสนสวยงามนี้!",
          text_en: " 3. The characters now possess their own consciousness; in fact, they are now akin to humans. Please treat them with respect.\n4. Please distinguish between fact and fiction. Listen to the characters; they will guide you in behaving appropriately.\n5. Each character has their own way of communicating, but they are all friendly and eager to brighten your journey. Relax and enjoy the many activities you will experience.\n\nThank you for joining us on this once in a lifetime journey!"
        }
      }
    ]
  };

  // --- Active tab & page state ---
  const [activeTab, setActiveTab] = useState("oal"); // default 'oal'
  const [pageIndex, setPageIndex] = useState(0); // always start at page 0

  // --- Handle bookmark click ---
  const handleBookmarkClick = (tab) => {
    setActiveTab(tab.id);
    setPageIndex(0); // always reset to first page
    navigate(`/oal`); // update URL if needed
  };

  // --- Handle next/prev page ---
  const handleNextPage = () => {
    if (pageIndex < tabPages[activeTab].length - 1) setPageIndex(pageIndex + 1);
  };
  const handlePrevPage = () => {
    if (pageIndex > 0) setPageIndex(pageIndex - 1);
  };

  const handlePlay = () => {
    const src =
      lang === "TH"
        ? "/books/sound_thai.mp3"
        : "/books/sound_eng.mp3";

    if (!audioRef.current) {
      audioRef.current = new Audio(src);
      audioRef.current.loop = false;
    }

    if (isPlaying) {
      audioRef.current.pause();
      setIsPlaying(false);
    } else {
      audioRef.current.play().catch(console.error);
      setIsPlaying(true);
    }
  };

  const currentPage = tabPages[activeTab][pageIndex];

  useEffect(() => {
    return () => {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
      }
    };
  }, []);

  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
      audioRef.current = null;
      setIsPlaying(false);
    }
  }, [lang]);

  return (
    <div className="w-full overflow-x-auto bg-gradient-to-b from-[#131b33] to-black">
      <div className="flex justify-center items-center w-full min-h-screen">
        <div
          className="
            relative
            aspect-[16/10]
            w-full
            max-w-[1080px]
            min-w-[250px]
          "
        >
          {/* BACKGROUND IMAGES */}
          <img src="/books/coverbook_brown.webp" className="absolute inset-0 object-cover z-0" />
          <img src="/books/postcard.webp" className="absolute inset-0 object-cover w-6/12 z-10 -top-2" />

          <img
            src="/books/home_icon.webp"
            alt="home icon"
            className="absolute z-[60] mt-[10%] left-[2%] w-[3%] cursor-pointer"
            onClick={() => navigate("/")}
          />

          <img src="/books/bottom.webp" className="absolute inset-0 object-cover z-10 pointer-events-none" />
          <img src="/books/middle.webp" className="absolute inset-0 object-cover z-20 pointer-events-none" />
          <img src="/books/above.webp" className="absolute inset-0 object-cover z-30 pointer-events-none" />

          {/* --- BOOKMARKS --- */}
          <div className="absolute right-[0%] mt-[10%] z-20 flex flex-col gap-3 pointer-events-auto w-[10%]">
            {tabs.map((tab) => {
              const isActive = activeTab === tab.id;
              return (
                <motion.div
                  key={tab.id}
                  className="relative cursor-pointer"
                  onClick={() => handleBookmarkClick(tab)}
                  whileHover={{ scale: 1.05 }}
                >
                  <img
                    src={isActive ? "/books/bookmark_active.webp" : "/books/bookmark_inactive.webp"}
                    alt={tab.label}
                    className={isActive ? "w-[100%]" : "w-[120%]"}
                  />
                  <span
                    className={`absolute inset-0 ml-2 flex items-center justify-center text-black font-bold font-eng
                    ${isActive ? "text-[clamp(0.1rem,2vw,0.9rem)]" : "text-[clamp(0.1rem,2vw,0.8rem)]"}`}
                  >
                    {tab.label}
                  </span>
                </motion.div>
              );
            })}
          </div>

          {/* --- CONTENT AREA --- */}
          <div className="absolute top-[8%] left-0 right-0 z-50 px-[10%] flex gap-8 h-[65%]">

            {/* LEFT PAGE */}
            <div className="w-1/2 p-[0.2%] overflow-y-auto">
              <h2 className="font-bold mb-3 font-eng
               text-[clamp(0.8rem,2vw,1.6rem)]">
                {currentPage.left.title}
              </h2>

              <p className={`text-gray-800 whitespace-pre-line leading-relaxed
              text-[clamp(0.5rem,1.5vw,1.1rem)]
              ${lang == "TH" ? "font-thai" : "font-eng"}`}>
                {lang == "TH" ? currentPage.left.text_th : currentPage.left.text_en}
              </p>
            </div>

            {/* RIGHT PAGE */}
            <div className="w-1/2 p-[0.2%] overflow-y-auto">
              <h2
                className={`font-bold mb-3 font-eng
               text-[clamp(0.8rem,2vw,1.6rem)]
                ${currentPage.right.title === currentPage.left.title ? "opacity-0" : "opacity-100"
                  }`}
              >
                {currentPage.right.title}
              </h2>
              <p className={`text-gray-800 whitespace-pre-line leading-relaxed
              text-[clamp(0.5rem,1.5vw,1.1rem)]
              ${lang == "TH" ? "font-thai" : "font-eng"}`}>
                {lang == "TH" ? currentPage.right.text_th : currentPage.right.text_en}
              </p>
            </div>

          </div>

          <motion.button
            className="absolute top-[70%] left-[10%] z-[60] p-2 rounded-full hover:bg-white"
            onClick={handlePlay}
            whileHover={{ scale: 1.1 }}
          >
            {isPlaying ? (
              <StopIcon className="w-2 h-2 md:w-6 md:h-6" />
            ) : (
              <PlayIcon className="w-2 h-2 md:w-6 md:h-6" />
            )}
          </motion.button>

          <motion.button
            className="absolute top-[75%] left-[10%] z-[60] p-2 rounded-full hover:bg-white"
            onClick={handlePrevPage}
            disabled={pageIndex === 0}
            whileHover={{ scale: 1.1 }}
          >
            <ArrowLeftIcon className="w-2 h-2 md:w-6 md:h-6" />
          </motion.button>

          <motion.button
            className="absolute top-[75%] right-[12%] z-[60] p-2 rounded-full hover:bg-white"
            onClick={handleNextPage}
            disabled={pageIndex === tabPages[activeTab].length - 1}
            whileHover={{ scale: 1.1 }}
          >
            <ArrowRightIcon className="w-2 h-2 md:w-6 md:h-6" />
          </motion.button>
        </div>
      </div>
    </div>
  );
}

export default BrownBookPage;
